import { UI_Spinner } from 'ui/components/1-atoms/Media/Spinner/Spinner';
import styles from './NewsList.module.scss';
import classNames from 'classnames';
import { UI_NewsCard } from 'ui/components/2-molecules/Card/NewsCard/NewsCard';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';

export interface NewsListProps {
	link?: {
		url: string;
		name?: string;
		target?: string;
	};
	newsResult: { isLoading: boolean; articles?: NewsCardProps[] };
	isTeaserList?: boolean;
	teaserHeading?: string | null;
	columns?: '2' | '3' | '4';
}

interface NewsCardProps {
	className?: string;
	heading: string;
	link?: {
		url: string;
		target?: string;
		name?: string;
	};
	kicker: string;
	text: string;
	date: string;
	image?: {
		url: string;
		focalPoint?: { left: number; top: number };
		extension?: string;
	};
	imageCropping?: 'cover' | 'contain';
	altText?: string;
}

interface ListProps {
	items: NewsCardProps[];
	className?: string;
	link?: {
		url: string;
		name?: string;
		target?: string;
	};
	teaserHeading?: string | null;
	isTeaserList?: boolean;
	columns?: '2' | '3' | '4';
}

export const UI_NewsList = ({ link, newsResult, isTeaserList, teaserHeading, columns = '4' }: NewsListProps) => {
	if (newsResult.isLoading) return <UI_Spinner />;
	if (!newsResult.articles) return <></>;

	return (
		<NewsList
			className={classNames(
				{ [styles.NewsList__teaser]: isTeaserList },
				{ [styles.NewsList__teaserTwoCol]: columns === '2' },
				{ [styles.NewsList__teaserThreeCol]: columns === '3' },
				{ [styles.NewsList__teaserFourCol]: columns === '4' },
			)}
			items={newsResult.articles.map((item) => ({
				...item,
			}))}
			link={link}
			teaserHeading={teaserHeading}
			isTeaserList={isTeaserList}
			columns={columns}
		/>
	);
};

export const NewsList = ({ items, link, className, teaserHeading, isTeaserList }: ListProps) => {
	if (!items) return null;

	const grid = (
		<section className={classNames(styles.NewsList__section, { [styles.NewsList__sectionTeaser]: isTeaserList })}>
			{isTeaserList && (
				<div className={styles.NewsList__header}>
					{teaserHeading && (
						<UI_Heading className={styles.NewsList__title} style="smd" headingLevel="h2">
							{teaserHeading}
						</UI_Heading>
					)}
					{link && (
						<UI_Link className={styles.NewsList__link} url={link.url} target={link.target}>
							{link.name}
						</UI_Link>
					)}
				</div>
			)}
			<div className={classNames(styles.NewsList, className)}>
				{items.map((item, index) => {
					return <UI_NewsCard {...item} key={index} />;
				})}
			</div>
		</section>
	);

	return grid;
};
